<template>
  <div>
    <breadcrumb></breadcrumb>
    <con-title>产品展示</con-title>
    <div class="con w">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/CRM.png" alt="" />
            </div>
            <span>CRM</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/ERP.png" alt="" />
            </div>
            <span>ERP</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/大数据分析.png" alt="" />
            </div>
            <span>大数据分析</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/市场助手.png" alt="" />
            </div>
            <span>市场帮手</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/待办派单.png" alt="" />
            </div>
            <span>待办派单</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/智能过户.png" alt="" />
            </div>
            <span>智能过户</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/管车助手.png" alt="" />
            </div>
            <span>管车助手</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="products-box">
            <div class="products-img">
              <img src="../../assets/cp/金融风控.png" alt="" />
            </div>
            <span>金融风控</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.con {
  padding: 40px 0;
}
.products-box {
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .products-img {
    width: 80%;
    height: 80px;
    display: flex;
    justify-content: center;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
